import React from 'react';
import { observer } from 'mobx-react';

import { formatDueDate } from 'utils/date';

import { colors } from 'theme/colors';

import { Value } from './styles';

const OVERDUE_STATUS = 'overdue';

const DueDate: React.FunctionComponent<{
  date?: string | number;
  alwaysShowYear?: boolean;
  showTime?: boolean;
  status?: string;
}> = ({ date, alwaysShowYear, showTime, status, ...props }): React.ReactElement => {
  if (date === undefined || date === null) {
    return <Value $color={colors.text.secondary}>No Due Date</Value>;
  }
  const { name, color } = formatDueDate(date, { alwaysShowYear, showTime });

  // On audit surfaces (showTime) red keys off the backend-computed status so the cell, its colour and the
  // status chip always agree, even under client-clock skew. Elsewhere `status` is a TaskStatus that is never
  // 'overdue', so we leave formatDueDate's own client-clock colour untouched and keep overdue tasks red.
  let finalColor = color;
  if (showTime && status !== undefined) {
    if (status === OVERDUE_STATUS) {
      finalColor = colors.error.main;
    } else if (color === colors.error.main) {
      // Backend says this isn't overdue (e.g. clock skew); don't render it red.
      finalColor = colors.text.secondary;
    }
  }

  return (
    <Value $color={finalColor} {...props} id="due-date-value" data-testid="due-date">
      {name}
    </Value>
  );
};

export default observer(DueDate);
